import { Box, Circle, CircularProgress, Text } from "@chakra-ui/react";
import { ReactComponent as Users } from '../../svg/group-of-two.svg'
import { ReactComponent as Certificates } from '../../svg/certificate.svg'
import { ReactComponent as Participants } from '../../svg/group-of-three.svg'
import { ReactComponent as Quiz } from '../../svg/puzzle-piece.svg'
import {ReactComponent as Danger} from '../../svg/danger.svg'
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadStatistics } from "../../redux/api_calls/apiCalls";
import { useSelector } from "react-redux";


export default function Statistics({course_id}) {
    const dispatch = useDispatch()
    const { statisticsData, isLoading } = useSelector(state => state.statisticsState)

    useEffect(() => {
        dispatch(loadStatistics("course", course_id))
        // eslint-disable-next-line
    }, [])
    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
        >
            <Text
                fontSize='15px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                mb='1rem'
            >
                STATISTICS
            </Text>


            <Box
                w='100%'
                d='flex'
                justifyContent='space-between'
                flexWrap='wrap'
                style={{ gap: '0.5rem' }}
            >

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#3A7DFD1A' mr='1rem'>
                        <Participants width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            Total Participants
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.no_of_participants}
                                </Text>
                        }
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#F9E4E3' mr='1rem'>
                        <Quiz stroke='#967132' fill='#967132' width='25px' height='25px'  />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            Total Mid-term Quizzes
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.mid_term_quizz}
                                </Text>
                        }
                    </Box>
                </Box>

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#E5F7FF' mr='1rem'>
                        <Users width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            Participants with High Score
                        </Text>
                        {isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                            <Text
                                fontSize='24px'
                                fontWeight='800'
                                color='#000000'
                            >
                                {statisticsData[0]?.high_score_peoples}
                            </Text>
                        }
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#E1F0E9' mr='1rem'>
                        <Certificates width='25px' height='25px' fill='#26CE83' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            Certificates Provided
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.certificate_provided}
                                </Text>
                        }
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#F8F3D6' mr='1rem'>
                        <Quiz stroke='#967132' fill='#967132' width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            Total End-term Quizzes
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.end_term_quizz}
                                </Text>
                        }
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#FCE4F0' mr='1rem'>
                        <Danger width='25px' height='25px' stroke='red' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            Participants with Low Scores
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.low_score_peoples}
                                </Text>
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}